import React from "react";
import { DialogActions, DialogContent, Typography, Dialog, Button } from "@material-ui/core";
import RoleService from '../../../../../../services/RoleService/RoleService'
import UserService from "../../../../../../services/UserService/UserService";
import { useTranslation } from 'react-i18next'
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../../../recoil-store/recoil-state';

function Modal(props) {

    const { t } = useTranslation();
    const handleClose = () => {
        props.setOpen(false);
    };
    const setAlert = useSetRecoilState(alertState);

    const handleDelete = async () => {

        const deletedRole = []
        deletedRole.push(props.roleItem)
        const data = {
            user_role: [
                {
                    userId: props.user,
                    willBeAddedRole: [],
                    willBeDeletedRole: deletedRole,
                }
            ]
        }

        const response = await RoleService.updateUserRoles(data);
        if (!response) {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t(`CONTENT.USER.${response.message}`), severity: response.status ? 'success' : 'error' }));
        }
        UserService.getUserByID(props.user).then((responseI) => {
            props.setRoles(responseI.data.data.roles)
        })
        props.setOpen(false)
    };

    return (
        <Dialog aria-labelledby="customized-dialog-title" open={props.open}>
            <DialogContent dividers>
                <Typography>Rol'ü silmek üzeresiniz, Emin misiniz?</Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus color="primary" onClick={handleDelete}>
                    Sil
                </Button>
                <Button onClick={handleClose}>iptal et</Button>
            </DialogActions>
        </Dialog>
    );
}
export default Modal;
